<star-rating [rating]="rating" [starType]="'svg'" labelPosition="right" labelText="{{rating | number:'1.0-2':numberFormatLocale}}" readOnly="true"
             showHalfStars="true"
             size="{{size}}" style="display: inline-flex;"></star-rating>
